export interface NavbarItem {
  title: string
  href: string
  external?: boolean
  requiredRoles?: string[]
  requiredCondition?: string
}

export interface NavbarSection {
  title: string
  items?: NavbarItem[]
  href?: string
  description?: string
  requiredRoles?: string[]
  requiredCondition?: string
}

export const adventuresItems: NavbarSection[] = [
  {
    title: 'Browse & Plan',
    items: [
      { title: 'Browse Adventures', href: '/hunts' },
      { title: 'My Adventures', href: '/adventures' },
      { title: 'Hunt Plans', href: '/hunt_plans' },
    ],
  },
  {
    title: 'Applications & Tracking',
    items: [
      { title: 'Hunt Achievements', href: '/user_hunt_achievements' },
      { title: 'State Applications', href: '/user_state_applications' },
      { title: 'State Reminders', href: '/profile/state_reminders' },
    ],
  },
]

export const storeItems: NavbarSection[] = [
  {
    title: 'Products',
    items: [
      { title: 'Products', href: '/products', requiredCondition: 'products_enabled' },
      { title: 'Rifles', href: '/rifles', requiredCondition: 'rifles_enabled' },
      { title: 'Courses', href: '/courses', requiredCondition: 'courses_enabled' },
    ],
  },
]

export const advisorItems: NavbarSection[] = [
  {
    title: 'Overview',
    items: [
      { title: 'Advisor Dashboard', href: '/act_as_rep' },
    ],
  },
  {
    title: 'Agency Management',
    items: [
      { title: 'My Agency', href: '/members' },
      // { title: 'Commissions', href: '/commissions' },
      { title: 'Commission Report', href: '/commissions_report' },
      { title: 'Agency Purchases', href: '/purchases' },
      { title: 'Applications', href: '/rep_state_applications' },
    ],
  },
  {
    title: 'Products',
    items: [
      { title: 'Specialist Products', href: '/products?specific_type=specialist' },
    ],
  },
]

export const adminItems: NavbarSection[] = [
  {
    title: 'Administration',
    items: [
      { title: 'Admin Dashboard', href: '/oss/admin_dashboard' },
      { title: 'Prev Admin Dashboard', href: '/profile/redirect_to_nrads?destination=admindashboard' },
      { title: 'Users', href: '/users' },
      { title: 'Purchases', href: '/oss/oss_purchases' },
      // { title: 'Recent Notes', href: '/recent_notes' },
      { title: 'Commission Reports', href: '/commissions_report' },
    ],
  },
]

export const superadminItems: NavbarSection[] = [
  {
    title: 'Content Management',
    items: [
      { title: 'Species', href: '/species' },
      { title: 'Mail Templates', href: '/mail_templates' },
      { title: 'Hunt Achievements', href: '/cms/hunt_achievements' },
      { title: 'Listing Changes', href: '/cms/listing_changes' },
      { title: 'Out of Date Hunts', href: '/cms/out_of_date_hunts' },
    ],
  },
  {
    title: 'System Admin',
    items: [
      { title: 'Tenants', href: '/tenants' },
      { title: 'Tenant Settings', href: '/tenants/current/edit' },
      { title: 'State Applications', href: '/superadmin/annual_state_animals' },
      { title: 'QuickBooks', href: '/qb/quickbooks/integration' },
      { title: 'Changelog', href: '/cms/changelog' },
      { title: 'Permissions Analyzer', href: '/tools/permissions' },
    ],
  },
  {
    title: 'External Hubs',
    items: [
      { title: 'Spearfish', href: 'https://spearfish.myadventurehub.com', external: true },
      { title: 'Tulsa', href: 'https://tulsa.myadventurehub.com', external: true },
      { title: 'Brigham City', href: 'https://brighamcity.myadventurehub.com', external: true },
      { title: 'Kearney', href: 'https://kearney.myadventurehub.com', external: true },
    ],
  },
]

export interface UserMenuItem {
  label: string
  href: string
  separator?: 'before' | 'after'
  dataMethod?: string
  className?: string
  external?: boolean
  requiredRoles?: string[]
  requiredCondition?: string
}

export const userMenuItems: UserMenuItem[] = [
  { label: 'Profile', href: '/profile/edit' },
  { label: 'Change Password', href: '/profile/password' },
  { label: 'Subscriptions', href: '/profile/subscriptions', requiredCondition: 'has_subscription' },
  { label: 'Switch to Member', href: '/act_as_member', requiredRoles: ['member'], separator: 'before' },
  { label: 'Switch to Advisor', href: '/act_as_rep', requiredRoles: ['rep'], separator: 'after' },
  { label: 'Terms of Service', href: '', external: true, requiredCondition: 'terms_url' },
  { label: 'Stop Masquerading', href: '/profile/stop_impersonating', dataMethod: 'post', requiredCondition: 'impersonating', className: 'text-orange-600 hover:text-orange-700', separator: 'before' },
  { label: 'Log Out', href: '/users/sign_out', dataMethod: 'delete', className: 'text-red-600 hover:text-red-700', separator: 'before' },
]
